var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/1.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Antes de comprar uma área você deve exigir do vendedor que demonstre:"
                )
              ]),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "a cadeia dominial completa da área (documento do cartório que conta toda a história da área desde o seu primeiro dono);"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "a confirmação de que a área tem um título de terras expedido pelo Poder Público em nome do primeiro dono;"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "que este título em nome do primeiro dono tem a mesma localização ao da área que o vendedor quer lhe vender;"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "caso a área tenha documentos e você tenha dúvidas se ele legítimo ou não procure um especialista no assunto ou o " +
                      _vm._s(_vm.ORGAO) +
                      " para te orientar;"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "caso a área tenha documentos frágeis ou não tenha nenhum documento, tome as orientações abaixo:"
                  )
                ]),
                _c("ul", [
                  _c("li", [
                    _c("i", [
                      _vm._v(
                        "Obs: Procure o Cartorário do Registro de Imóveis da localidade do imóvel para te orientar ou entre em contato com (91) 3181 6500."
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/2.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "O Cadastro Ambiental Rural (CAR), a Declaração do " +
                    _vm._s(_vm.SISTEMA) +
                    " e escrituras públicas de compra e venda ou contratos particulares não são documentos que comprovam a propriedade privada ou direitos sobre\n a terra, e nem servem como garantia que a área será regularizada."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/3.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Um título de terras expedido pelo " +
                    _vm._s(_vm.ORGAO) +
                    " não autoriza desmatar. Para qualquer supressão de floresta você deverá obter a licença ambiental."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/4.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Um título de terras somente é expedido após o cumprimento de todo procedimento legal que envolve análises jurídica e técnica (cartográfica, fiscalização de georreferenciamento e vistoria de campo)."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/5.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "A partir de 2019 o " +
                    _vm._s(_vm.ORGAO) +
                    " passou a utilizar imagens de satélites de alta resolução para identificar as áreas, a situação da floresta e a atividade produtiva."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/6.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "A partir de agosto de 2020 o " +
                    _vm._s(_vm.ORGAO) +
                    " fará a utilização de dados ambientais da SEMAS e do IDEFLOR-Bio, bem como de dados de produção da SEDAP, EMATER, SEDEME e ADEPARÁ com objetivo de avaliar o processo\n de ocupação e uso da área para fins de comprovação de atividade produtiva pelo requerente da regularização."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/7.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c(
                "li",
                [
                  _vm._v(
                    "Confirme se a área tem algum passivo ambiental, multa ou embargo do IBAMA, da Secretaria Estadual de Meio Ambiente ou da Secretaria Municipal de Meio Ambiente"
                  ),
                  _c("span", [_vm._v("  (acesse:")]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "font-size": "1em" },
                      attrs: { type: "text" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticStyle: { "text-decoration": "none" },
                          attrs: {
                            target: "_blank",
                            href: "http://www.semas.pa.gov.br"
                          }
                        },
                        [
                          _c("span", { staticClass: "url" }, [
                            _vm._v("www.semas.pa.gov.br")
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(")")
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/8.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "O que você precisa saber antes de pedir a regularização de uma área no " +
                    _vm._s(_vm.ORGAO) +
                    ":"
                )
              ]),
              _c("ul", [
                _c("li", [_vm._v("o que o " + _vm._s(_vm.ORGAO) + " faz:")]),
                _c("ul", [
                  _c("li", [
                    _vm._v("1.  regulariza áreas de domínio do Estado do Pará;")
                  ]),
                  _c("li", [
                    _vm._v("2. regulariza áreas que nunca foram tituladas;")
                  ])
                ]),
                _c("li", [
                  _vm._v("O que o " + _vm._s(_vm.ORGAO) + " não faz:")
                ]),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "1. não regulariza áreas da União, do INCRA e de municípios;"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "2. não regulariza áreas em Unidades de Conservação federais, territórios criados ou de pretensão quilombolas, de comunidades tradicionais em terras da União, territórios indígenas criados ou em estudo,\n terrenos de marinha e seus acrescidos;"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "3. não regulariza Unidades de Conservação estaduais em que não é permitida a propriedade privada; territórios criados ou de pretensão quilombolas, de comunidades tradicionais em terras do Estado do Pará\n criados ou sob pretensão; áreas destinadas para concessão florestal de acordo com o IDEFLOR-Bio."
                    )
                  ])
                ])
              ]),
              _c("br"),
              _c("li", [
                _c("i", [
                  _vm._v(
                    "Obs: Os informativos têm natureza meramente exemplificativa, podendo ocorrer outras situações."
                  )
                ])
              ]),
              _c("li", [
                _c(
                  "i",
                  [
                    _vm._v(
                      "Para saber se a área do seu interesse não recai em áreas impedidas, consulte o mapa do " +
                        _vm._s(_vm.SISTEMA) +
                        " que tem natureza orientativa acessando o link:  "
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "font-size": "1em" },
                        attrs: { type: "text" }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-decoration": "none" },
                            attrs: {
                              target: "_blank",
                              href: "http://sicarf.iterpa.pa.gov.br/"
                            }
                          },
                          [
                            _c("span", { staticClass: "url" }, [
                              _vm._v("sicarf.iterpa.pa.gov.br")
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(")")
                  ],
                  1
                )
              ]),
              _c("li", [
                _c("i", [
                  _vm._v(
                    "Obs: a confirmação que a área não está em espaço impedido, não gera expectativa de direito à regularização fundiária."
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/9.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "O " +
                    _vm._s(_vm.ORGAO) +
                    " apenas entrará em contato como você pelos seus canais oficiais que estão dispostos nesta página."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/10.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Se alguém entrar em contato com você em nome do " +
                    _vm._s(_vm.ORGAO) +
                    ", peça o número da matrícula funcional da pessoa ou do seu credenciamento."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/11.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Ninguém está autorizado em falar em nome do " +
                    _vm._s(_vm.ORGAO) +
                    " e nem vender serviços privados de regularização fundiária em seu nome;"
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/12.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Caso alguém queira vender serviços de regularização fundiária em nome do " +
                    _vm._s(_vm.ORGAO) +
                    ", primeiro pegue os dados da matrícula funcional, número do credenciado e/ou contatos (e-mail e telefone).\n Em seguida, entre em contato com o " +
                    _vm._s(_vm.ORGAO) +
                    " para obter a confirmação."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/13.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Ninguém está autorizado a utilizar os símbolos do " +
                    _vm._s(_vm.ORGAO) +
                    " ou do Governo do Estado do Pará visando presumir ser servidor público ou obter facilidades em processos de regularização fundiária.\n Para se prevenir de golpes e problemas futuros, adote o procedimento indicado no item 12."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/14.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "A partir de junho de 2020 todos os documentos do " +
                    _vm._s(_vm.ORGAO) +
                    " somente terão validade se expedidos com certificado digital e assinatura eletrônica, que você poderá comprovar a autenticidade pelo aplicativo ou portal " +
                    _vm._s(_vm.SISTEMA) +
                    " do " +
                    _vm._s(_vm.ORGAO) +
                    ",\n sem a necessidade de dirigir-se ao órgão fundiário."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/15.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Prestar informação falsa em pedidos dos serviços do " +
                    _vm._s(_vm.ORGAO) +
                    " é crime que sujeita a pessoa à responsabilidade criminal e a nulidade do processo de regularização fundiária e do título, caso tenha sido expedido."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/16.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Leia atentamente o que está escrito no seu título. Nele constam obrigações que você deve atender. No caso do não atendimento ou violação ele poderá ser cancelado e a área retomada pelo Estado."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/17.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Além dos símbolos do " +
                    _vm._s(_vm.ORGAO) +
                    " e do Governo do Estado leia sempre o conteúdo do documento expedido pelo órgão fundiário."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/18.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Você sabe como você pode acelerar a análise do seu pedido de regularização fundiária?"
                )
              ]),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "protocole todos os documentos do requerente corretamente e legíveis (boa definição);"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "protocole todas as peças técnicas de georreferenciamento e no formato correto;"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "preste todas as informações solicitadas com clareza, objetividade e honestidade;"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "responda da forma correta e o mais breve possível as notificações feitas pelo órgão."
                  )
                ])
              ]),
              _c("br"),
              _c("li", [
                _c("i", [
                  _vm._v(
                    "Obs: lembre-se que, quanto mais organizado e com os documentos corretos, o seu pedido será analisado com mais rapidez porque você não perderemos tempo te notificando e você levando tempo para responder."
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/19.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Quando o seu processo é arquivado você deverá pagar custas para o desarquivamento."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation red"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/20.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Em breve, o " +
                    _vm._s(_vm.ORGAO) +
                    " disponibilizará no seu site e no portal " +
                    _vm._s(_vm.SISTEMA) +
                    " a lista dos profissionais com credenciamento no órgão para execução do georreferenciamento e vistoria da regularização fundiária onerosa ou não onerosa. O " +
                    _vm._s(_vm.ORGAO) +
                    " não se responsabiliza pela relação contratual entre as partes\n que tem a natureza de direito privado. Caberá apenas ao " +
                    _vm._s(_vm.ORGAO) +
                    ", no caso de má conduta e/ou baixa qualidade da prestação\n de serviço de georreferenciamento e/ou vistoria, suspender e/ou cancelar o credenciamento, bem como comunicar o órgão de classe competente\n acerca da falta, após o devido processo legal."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle iconExclamation orange"
          }),
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/21.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  " Se você tomar conhecimento de alguma irregularidade use o nosso canal de denúncia. Nos ajude a combater a grilagem de terras públicas estaduais. Garantimos o sigilo."
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6257a14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6257a14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/informacao/ObservacoesImportantes.vue
// module id = null
// module chunks = 